(function () {
  function readEmbeddedConfig() {
    var element = document.getElementById("cp-variant-grid-config");
    if (!element) return {};

    try {
      return JSON.parse(element.textContent || "{}");
    } catch (error) {
      console.warn("[CPVariantGrid] Invalid embedded config", error);
      return {};
    }
  }

  var CONFIG = Object.assign(
    {
      mode: "",
      model: "",
      optionName: "Selecione o seu modelo",
      collectionHandle: "",
      collectionTitle: "",
      variantCollectionHandles: [],
      variantProductIds: null,
      sort: "",
      pageSize: 0,
      hideValues: ["-"],
      showUnavailable: true,
      debug: false,
    },
    readEmbeddedConfig(),
    window.CPVariantGridConfig || {}
  );

  var KNOWN_MODELS = [
    "iPhone 6 7 8 SE2022",
    "iPhone 17 Pro Max",
    "iPhone 17 Pro",
    "iPhone 17 Air",
    "iPhone 17e",
    "iPhone 17",
    "iPhone 16 Pro Max",
    "iPhone 16 Pro",
    "iPhone 16 Plus",
    "iPhone 16e",
    "iPhone 16",
    "iPhone 15 Pro Max",
    "iPhone 15 Pro",
    "iPhone 15",
    "iPhone 14 Plus e 15 Plus",
    "iPhone 14 Pro Max",
    "iPhone 14 Pro",
    "iPhone 14 Plus",
    "iPhone 14",
    "iPhone 13 Pro Max",
    "iPhone 13 Pro",
    "iPhone 13",
    "iPhone 12 Pro Max",
    "iPhone 12 e 12 Pro",
    "iPhone 12 Pro",
    "iPhone 12",
    "iPhone 11 Pro Max",
    "iPhone 11 Pro",
    "iPhone 11",
    "iPhone XR",
    "iPhone XS Max",
    "iPhone XS",
    "iPhone X",
  ].sort(function (a, b) {
    return normalize(b).length - normalize(a).length;
  });

  var productCache = new Map();
  var renderTimer = null;
  var isRendering = false;
  var needsRenderAfterCurrent = false;
  var lastSignature = "";
  var loadingTimer = null;
  var forcedLoadingUntil = 0;
  var paginatedGrid = null;
  var scrollAfterPage = false;
  var COLLECTIONS_WITHOUT_COMBOS = ["aurora", "nora", "odara"];
  var EXCLUDED_COMBO_PRODUCT_HANDLES = [
    "kit-areia-aurora-nora-dourada",
    "kit-areia-odara-aurora-dourada",
    "kit-areia-nora-odara-dourada",
    "kit-areia-aurora-nora",
    "kit-marrom-cafe-aurora-nora-dourada",
    "kit-marrom-cafe-aurora-odara-dourada",
    "kit-marrom-cafe-aurora-nora",
    "kit-marrom-cafe-odara-aurora",
    "kit-mocha-mousse-odara-nora-dourada",
    "kit-mocha-mousse-aurora-nora",
    "kit-mocha-mousse-odara-nora",
    "kit-bordo-aurora-nora-dourada",
    "kit-bordo-aurora-odara-dourada",
    "kit-bordo-aurora-nora",
    "kit-trio-areia-aurora-nora-odara",
    "kit-trio-marrom-cafe-aurora-nora-odara",
    "kit-trio-mocha-mousse-aurora-nora-odara",
    "kit-trio-bordo-aurora-nora-odara",
  ];

  function log() {
    if (!CONFIG.debug) return;
    console.log.apply(console, ["[CPVariantGrid]"].concat(Array.prototype.slice.call(arguments)));
  }

  function normalize(value) {
    return String(value || "")
      .normalize("NFD")
      .replace(/[\u0300-\u036f]/g, "")
      .toLowerCase()
      .replace(/[^a-z0-9]+/g, " ")
      .trim()
      .replace(/\s+/g, " ");
  }

  function moneyFromCents(cents) {
    return new Intl.NumberFormat("pt-BR", {
      style: "currency",
      currency: "BRL",
    }).format(Number(cents || 0) / 100);
  }

  function escapeHtml(value) {
    return String(value || "")
      .replace(/&/g, "&amp;")
      .replace(/</g, "&lt;")
      .replace(/>/g, "&gt;")
      .replace(/"/g, "&quot;");
  }

  function getParams() {
    return new URLSearchParams(window.location.search);
  }

  function canonicalModel(value) {
    var normalizedValue = normalize(value);
    if (!normalizedValue) return "";

    if (
      normalizedValue === "iphone se2022" ||
      normalizedValue === "iphone se 2022"
    ) {
      return "iPhone 6 7 8 SE2022";
    }

    for (var i = 0; i < KNOWN_MODELS.length; i += 1) {
      if (normalizedValue.indexOf(normalize(KNOWN_MODELS[i])) !== -1) {
        return KNOWN_MODELS[i];
      }
    }

    // Generic collection copy can mention iPhone without representing one model.
    // Only explicit known models (and the audited SE alias above) enable model mode.
    return "";
  }

  function getModelFromQuery(params, includeFilterParams) {
    var direct = params.get("cp_variant_model") || params.get("variant_model");
    if (direct) return canonicalModel(direct);
    if (!includeFilterParams) return "";

    var found = "";
    params.forEach(function (value, key) {
      if (found) return;
      if (key.indexOf("gf_") === 0 || key.indexOf("filter[") === 0) {
        found = canonicalModel(value);
      }
    });

    return found;
  }

  function inferModelFromCollection() {
    return (
      canonicalModel(CONFIG.collectionTitle) ||
      canonicalModel(String(CONFIG.collectionHandle || "").replace(/-/g, " "))
    );
  }

  function isDefaultVariantCollection() {
    var handles = Array.isArray(CONFIG.variantCollectionHandles)
      ? CONFIG.variantCollectionHandles
      : [];
    var collectionHandle = normalize(CONFIG.collectionHandle);

    return handles.some(function (handle) {
      return normalize(handle) === collectionHandle;
    });
  }

  function resolveState() {
    var params = getParams();
    var forcedMode = normalize(params.get("cp_variant_grid") || params.get("variant_grid"));
    var configuredMode = normalize(CONFIG.mode);
    var directQueryModel = getModelFromQuery(params, false);
    var queryModel = getModelFromQuery(params, true);
    var configuredModel = canonicalModel(CONFIG.model);
    var inferredModel = inferModelFromCollection();
    var model = queryModel || configuredModel || inferredModel;

    if (["off", "disabled", "desligado"].indexOf(forcedMode) !== -1) {
      return { mode: "off", model: "" };
    }

    if (["normal", "parent", "parents", "produto pai", "produto-pai"].indexOf(forcedMode) !== -1) {
      return { mode: "parent", model: "" };
    }

    if (forcedMode === "model" || forcedMode === "modelo" || directQueryModel) {
      return model ? { mode: "model", model: model } : { mode: "off", model: "" };
    }

    if (forcedMode === "variants" || forcedMode === "variant" || forcedMode === "promo") {
      return queryModel ? { mode: "model", model: queryModel } : { mode: "variants", model: "" };
    }

    if (configuredMode === "variants" || configuredMode === "variant" || configuredMode === "promo") {
      return queryModel ? { mode: "model", model: queryModel } : { mode: "variants", model: "" };
    }

    if (
      configuredMode === "normal" ||
      configuredMode === "parent" ||
      configuredMode === "parents" ||
      configuredMode === "produto pai" ||
      configuredMode === "produto-pai"
    ) {
      return { mode: "parent", model: "" };
    }

    if (isDefaultVariantCollection()) {
      return { mode: "variants", model: "" };
    }

    if (configuredMode === "model" || configuredMode === "modelo" || configuredModel || inferredModel) {
      return model ? { mode: "model", model: model } : { mode: "off", model: "" };
    }

    return { mode: "off", model: "" };
  }

  function shouldMaskGrid(state) {
    return state && (state.mode === "model" || state.mode === "variants");
  }

  function setGridLoading(active) {
    var root = document.documentElement;
    if (!root) return;

    root.classList.toggle("cp-variant-grid-loading", Boolean(active));

    if (active) {
      window.clearTimeout(loadingTimer);
      loadingTimer = window.setTimeout(function () {
        root.classList.remove("cp-variant-grid-loading");
      }, 25000);
      return;
    }

    window.clearTimeout(loadingTimer);
    loadingTimer = null;
  }

  function isLoadingForced() {
    return forcedLoadingUntil > Date.now();
  }

  function clearForcedLoading() {
    forcedLoadingUntil = 0;
  }

  function forceGridLoading() {
    var forcedMode = normalize(getParams().get("cp_variant_grid") || getParams().get("variant_grid"));
    if (
      ["off", "disabled", "desligado", "normal", "parent", "parents", "produto pai", "produto-pai"].indexOf(
        forcedMode
      ) !== -1
    ) {
      return;
    }

    if (!shouldMaskGrid(resolveState())) {
      return;
    }

    forcedLoadingUntil = Date.now() + 20000;
    setGridLoading(true);
  }

  function showLoadingIfNeeded() {
    var state = resolveState();
    if (getCardPageSize(state) && paginatedGrid && paginatedGrid.key === pageQueryKey() && !paginatedGrid.entries.length) {
      clearForcedLoading();
      setGridLoading(false);
      return;
    }
    if (shouldMaskGrid(state) && isLoadingForced() && !gridLooksReady(state)) {
      setGridLoading(true);
      return;
    }

    if (shouldMaskGrid(state) && isLoadingForced() && state.mode === "variants") {
      setGridLoading(true);
      return;
    }

    if (!shouldMaskGrid(state) || gridLooksReady(state)) {
      clearForcedLoading();
      setGridLoading(false);
      return;
    }

    if (shouldMaskGrid(state)) {
      setGridLoading(true);
    }
  }

  function getScope() {
    return (
      document.querySelector("#facet-main") ||
      document.querySelector(".product-facet__main") ||
      document.querySelector("main") ||
      document
    );
  }

  function getProductHandleFromHref(href) {
    if (!href) return "";

    try {
      var url = new URL(href, window.location.origin);
      var match = url.pathname.match(/\/products\/([^/?#]+)/);
      return match ? decodeURIComponent(match[1]) : "";
    } catch (error) {
      return "";
    }
  }

  function getProductHandle(card) {
    if (!card) return "";

    var storedHandle = card.getAttribute("data-cp-product-handle");
    if (storedHandle) return storedHandle;

    var links = card.querySelectorAll('a[href*="/products/"]');
    for (var i = 0; i < links.length; i += 1) {
      var handle = getProductHandleFromHref(links[i].getAttribute("href"));
      if (handle) return handle;
    }

    return "";
  }

  function getCurrentCollectionHandle() {
    try {
      var match = window.location.pathname.match(/\/collections\/([^/?#]+)/);
      if (match && match[1]) return decodeURIComponent(match[1]).toLowerCase();
    } catch (error) {
      // Fall back to the embedded config below.
    }

    return String(CONFIG.collectionHandle || "").toLowerCase();
  }

  function shouldExcludeComboCards() {
    return COLLECTIONS_WITHOUT_COMBOS.indexOf(getCurrentCollectionHandle()) !== -1;
  }

  function isExcludedComboProduct(card) {
    return EXCLUDED_COMBO_PRODUCT_HANDLES.indexOf(getProductHandle(card)) !== -1;
  }

  function removeExcludedComboCards() {
    if (!shouldExcludeComboCards()) return 0;

    var removed = 0;
    collectCards().forEach(function (card) {
      if (!isExcludedComboProduct(card) || !card.parentElement) return;
      card.parentElement.removeChild(card);
      removed += 1;
    });

    if (removed) {
      lastSignature = "";
      log("removed excluded combo cards", removed);
    }

    return removed;
  }

  function cardHasVariantLink(card) {
    var links = card ? card.querySelectorAll('a[href*="/products/"]') : [];
    for (var i = 0; i < links.length; i += 1) {
      if ((links[i].getAttribute("href") || "").indexOf("variant=") !== -1) {
        return true;
      }
    }

    return false;
  }

  function cardMatchesModel(card, model) {
    var wantedModel = normalize(model);
    if (!wantedModel) return true;

    var variantTitle = normalize(card.getAttribute("data-cp-variant-title"));
    if (variantTitle && variantTitle === wantedModel) return true;

    return normalize(card.textContent).indexOf(wantedModel) !== -1;
  }

  function cardWasMutatedForVariant(card) {
    return Boolean(card && card.getAttribute("data-cp-variant-id"));
  }

  function gridLooksReady(state) {
    if (!shouldMaskGrid(state)) return true;

    var cards = collectCards();
    if (!cards.length) return false;

    return cards.every(function (card) {
      if (Array.isArray(CONFIG.variantProductIds) && card.getAttribute("data-cp-variant-excluded") === "true") {
        return !cardWasMutatedForVariant(card) && !cardHasVariantLink(card);
      }

      return cardWasMutatedForVariant(card) && cardHasVariantLink(card) && cardMatchesModel(card, state.model);
    });
  }

  function collectCards() {
    var scope = getScope();
    var selector = [
      "product-item.product-item",
      ".collection__item.product-item",
      ".product-list__inner > .product-item",
      ".product-list__inner > product-item",
      ".spf-product-card",
      "[data-product-id]",
    ].join(",");

    var cards = Array.prototype.slice.call(scope.querySelectorAll(selector)).filter(function (card) {
      return Boolean(getProductHandle(card));
    });

    if (cards.length > 0) return cards;

    return Array.prototype.slice
      .call(scope.querySelectorAll('a[href*="/products/"]'))
      .map(function (link) {
        return link.closest(".product-item, product-item, .spf-product-card, [data-product-id]");
      })
      .filter(function (card, index, list) {
        return card && list.indexOf(card) === index && Boolean(getProductHandle(card));
      });
  }

  function getPrimaryParent(cards) {
    var counts = new Map();

    cards.forEach(function (card) {
      if (!card.parentElement) return;
      counts.set(card.parentElement, (counts.get(card.parentElement) || 0) + 1);
    });

    var winner = null;
    var winnerCount = 0;
    counts.forEach(function (count, parent) {
      if (count > winnerCount) {
        winner = parent;
        winnerCount = count;
      }
    });

    return winner;
  }

  function uniqueCardsByHandle(cards) {
    var seen = new Set();
    var unique = [];

    cards.forEach(function (card) {
      var handle = getProductHandle(card);
      if (!handle || seen.has(handle)) return;
      seen.add(handle);
      unique.push({ handle: handle, card: card });
    });

    return unique;
  }

  async function fetchProduct(handle) {
    if (productCache.has(handle)) return productCache.get(handle);

    var root = window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : "/";
    var url = root.replace(/\/?$/, "/") + "products/" + encodeURIComponent(handle) + ".js";
    var promise = fetch(url, { credentials: "same-origin" }).then(function (response) {
      if (!response.ok) throw new Error("Product JSON failed: " + handle);
      return response.json();
    });

    productCache.set(handle, promise);
    return promise;
  }

  function optionPosition(product) {
    var desired = normalize(CONFIG.optionName);
    var options = product && product.options ? product.options : [];

    for (var i = 0; i < options.length; i += 1) {
      if (normalize(options[i].name) === desired) {
        return Number(options[i].position || i + 1);
      }
    }

    for (var j = 0; j < options.length; j += 1) {
      var values = options[j].values || [];
      var hasKnownModel = values.some(function (value) {
        return Boolean(canonicalModel(value));
      });

      if (hasKnownModel) {
        return Number(options[j].position || j + 1);
      }
    }

    return 1;
  }

  function variantOptionValue(variant, position) {
    return (
      variant["option" + position] ||
      (variant.options && variant.options[position - 1]) ||
      variant.public_title ||
      variant.title ||
      ""
    );
  }

  function shouldHideVariant(value) {
    var hiddenValues = Array.isArray(CONFIG.hideValues) ? CONFIG.hideValues : ["-"];
    var normalizedValue = normalize(value);

    return hiddenValues.some(function (hiddenValue) {
      return normalize(hiddenValue) === normalizedValue;
    });
  }

  function displayableVariants(product, state) {
    var position = optionPosition(product);
    var wantedModel = normalize(state.model);

    return (product.variants || []).filter(function (variant) {
      var value = variantOptionValue(variant, position);
      if (shouldHideVariant(value)) return false;
      if (!CONFIG.showUnavailable && variant.available === false) return false;
      if (wantedModel && normalize(value) !== wantedModel) return false;
      return true;
    });
  }

  function shouldExpandProduct(product) {
    if (!Array.isArray(CONFIG.variantProductIds)) return true;

    return CONFIG.variantProductIds.some(function (id) {
      return String(id) === String(product.id);
    });
  }

  function findVariantForModel(product, model) {
    var variants = displayableVariants(product, { mode: "model", model: model });
    return variants[0] || null;
  }

  function variantImage(product, variant) {
    var image =
      (variant.featured_image && variant.featured_image.src) ||
      (variant.featured_media &&
        variant.featured_media.preview_image &&
        variant.featured_media.preview_image.src) ||
      product.featured_image ||
      (product.images && product.images[0]) ||
      "";

    if (image.indexOf("//") === 0) return window.location.protocol + image;
    return image;
  }

  function variantTitle(product, variant) {
    return variant.name || product.title + " - " + (variant.public_title || variant.title);
  }

  function canonicalProductPath(handle) {
    var root =
      (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || "/";
    return String(root).replace(/\/?$/, "/") + "products/" + encodeURIComponent(handle);
  }

  function variantUrlForHref(href, handle, variantId) {
    try {
      var url = new URL(href || "/products/" + handle, window.location.origin);
      if (!getProductHandleFromHref(url.href)) {
        return href;
      }

      url.pathname = canonicalProductPath(handle);
      url.searchParams.set("variant", variantId);
      return url.pathname + url.search + url.hash;
    } catch (error) {
      return canonicalProductPath(handle) + "?variant=" + variantId;
    }
  }

  function parentUrlForHref(href, handle) {
    try {
      var url = new URL(href || "/products/" + handle, window.location.origin);
      if (!getProductHandleFromHref(url.href)) {
        return href;
      }

      url.pathname = canonicalProductPath(handle);
      url.searchParams.delete("variant");
      return url.pathname + url.search + url.hash;
    } catch (error) {
      return canonicalProductPath(handle);
    }
  }

  function uniquifyIds(card, variantId) {
    if (card.getAttribute("data-cp-ids-unique") === String(variantId)) return;

    var idMap = new Map();
    Array.prototype.slice.call(card.querySelectorAll("[id]")).forEach(function (node) {
      var oldId = node.id;
      var newId = oldId + "-variant-" + variantId;
      node.id = newId;
      idMap.set(oldId, newId);
    });

    ["aria-controls", "aria-labelledby", "aria-describedby", "for"].forEach(function (attr) {
      Array.prototype.slice.call(card.querySelectorAll("[" + attr + "]")).forEach(function (node) {
        var current = node.getAttribute(attr);
        if (idMap.has(current)) {
          node.setAttribute(attr, idMap.get(current));
        }
      });
    });

    Array.prototype.slice.call(card.querySelectorAll('input[type="radio"][name]')).forEach(function (node) {
      node.name = node.name + "-variant-" + variantId;
    });

    card.setAttribute("data-cp-ids-unique", String(variantId));
  }

  function updateLinks(card, handle, variantId) {
    Array.prototype.slice.call(card.querySelectorAll('a[href*="/products/"]')).forEach(function (link) {
      var linkHandle = getProductHandleFromHref(link.getAttribute("href"));
      if (!linkHandle || linkHandle !== handle) return;
      link.setAttribute("href", variantUrlForHref(link.getAttribute("href"), handle, variantId));
    });

    Array.prototype.slice.call(card.querySelectorAll('quick-buy-popover[href], quick-buy-drawer[href]')).forEach(
      function (node) {
        var linkHandle = getProductHandleFromHref(node.getAttribute("href"));
        if (!linkHandle || linkHandle !== handle) return;
        node.setAttribute("href", variantUrlForHref(node.getAttribute("href"), handle, variantId));
      }
    );
  }

  function updateParentLinks(card, handle) {
    Array.prototype.slice.call(card.querySelectorAll('a[href*="/products/"]')).forEach(function (link) {
      var linkHandle = getProductHandleFromHref(link.getAttribute("href"));
      if (!linkHandle || linkHandle !== handle) return;
      link.setAttribute("href", parentUrlForHref(link.getAttribute("href"), handle));
    });

    Array.prototype.slice.call(card.querySelectorAll('quick-buy-popover[href], quick-buy-drawer[href]')).forEach(
      function (node) {
        var linkHandle = getProductHandleFromHref(node.getAttribute("href"));
        if (!linkHandle || linkHandle !== handle) return;
        node.setAttribute("href", parentUrlForHref(node.getAttribute("href"), handle));
      }
    );
  }

  function normalizeParentCardLinks(cards) {
    cards.forEach(function (card) {
      var handle = getProductHandle(card);
      if (handle) updateParentLinks(card, handle);
    });
  }

  function updateTitle(card, title) {
    var titleNodes = card.querySelectorAll(".product-item-meta__title, .product-item__title, [data-product-title]");
    Array.prototype.slice.call(titleNodes).forEach(function (node) {
      node.textContent = title;
    });
  }

  function updatePrice(card, variant) {
    var price = Number(variant.price || 0);
    var compareAt = Number(variant.compare_at_price || 0);
    var html =
      compareAt > price
        ? '<span class="price price--highlight"><span class="visually-hidden">Preco promocional</span>' +
          escapeHtml(moneyFromCents(price)) +
          '</span><span class="price price--compare"><span class="visually-hidden">Preco regular</span>' +
          escapeHtml(moneyFromCents(compareAt)) +
          "</span>"
        : '<span class="price"><span class="visually-hidden">Preco</span>' + escapeHtml(moneyFromCents(price)) + "</span>";

    var priceList = card.querySelector(".price-list");
    if (priceList) {
      priceList.innerHTML = html;
      return;
    }

    var priceNode = card.querySelector(".product-item__price, .price");
    if (priceNode) {
      priceNode.outerHTML = html;
    }
  }

  function discountRate(price, compareAt) {
    price = Number(price || 0);
    compareAt = Number(compareAt || 0);
    if (!Number.isFinite(price) || !Number.isFinite(compareAt) || price < 0 || compareAt <= 0 || compareAt <= price) return 0;

    return ((compareAt - price) / compareAt) * 100;
  }

  function discountLabel(price, compareAt) {
    var discount = discountRate(price, compareAt);
    if (!discount) return "";

    return Math.round(discount) + "% OFF";
  }

  function discountLabelNodes(card) {
    return Array.prototype.slice.call(
      card.querySelectorAll(
        [
          ".product-item__label-list .label--highlight",
          ".product-item__label-list .label--on-sale",
          ".label-list .label--highlight",
          ".label-list .label--on-sale",
          "[data-cp-discount-label]",
        ].join(",")
      )
    );
  }

  function preferredDiscountLabel(nodes) {
    return (
      nodes.find(function (node) {
        return node.classList.contains("label--highlight");
      }) || nodes[0]
    );
  }

  function getOrCreateDiscountLabel(card) {
    var nodes = discountLabelNodes(card);
    if (nodes.length) return nodes[0];

    var labelList = card.querySelector(".product-item__label-list, .label-list");
    if (!labelList) {
      var imageWrapper = card.querySelector(".product-item__image-wrapper");
      if (!imageWrapper) return null;

      labelList = document.createElement("div");
      labelList.className = "product-item__label-list label-list";
      imageWrapper.insertBefore(labelList, imageWrapper.firstChild);
    }

    var label = document.createElement("span");
    label.className = "label label--highlight";
    label.setAttribute("data-cp-discount-label", "true");
    labelList.insertBefore(label, labelList.firstChild);
    return label;
  }

  function updateDiscountLabel(card, price, compareAt) {
    card.setAttribute("data-cp-discount-rate", String(discountRate(price, compareAt)));
    var labelText = discountLabel(price, compareAt);
    var nodes = discountLabelNodes(card);

    if (!labelText) {
      nodes.forEach(function (node) {
        node.hidden = true;
        node.style.display = "none";
        node.setAttribute("data-cp-discount-label", "true");
      });
      return;
    }

    var label = preferredDiscountLabel(nodes) || getOrCreateDiscountLabel(card);
    if (!label) return;

    label.textContent = labelText;
    label.hidden = false;
    label.style.display = "";
    label.setAttribute("data-cp-discount-label", "true");

    nodes.forEach(function (node) {
      if (node === label) return;
      node.hidden = true;
      node.style.display = "none";
      node.setAttribute("data-cp-discount-label", "true");
    });
  }

  function updateProductPrice(card, product) {
    var variants = product.variants || [];
    if (!variants.length) return;

    var cheapest = variants.reduce(function (current, variant) {
      return Number(variant.price || 0) < Number(current.price || 0) ? variant : current;
    }, variants[0]);
    var prices = variants.map(function (variant) {
      return Number(variant.price || 0);
    });
    var minPrice = Math.min.apply(Math, prices);
    var maxPrice = Math.max.apply(Math, prices);
    var compareAt = Number(cheapest.compare_at_price || 0);
    // Parent cards can retain a stale sale badge from Globo's cached HTML.
    updateDiscountLabel(card, minPrice, compareAt);
    var minLabel = moneyFromCents(minPrice);
    var prefix = minPrice !== maxPrice ? "a partir de " : "";
    var html =
      compareAt > minPrice
        ? '<span class="price price--highlight"><span class="visually-hidden">Preco promocional</span>' +
          escapeHtml(prefix + minLabel) +
          '</span><span class="price price--compare"><span class="visually-hidden">Preco regular</span>' +
          escapeHtml(moneyFromCents(compareAt)) +
          "</span>"
        : '<span class="price"><span class="visually-hidden">Preco</span>' +
          escapeHtml(prefix + minLabel) +
          "</span>";

    var priceList = card.querySelector(".price-list");
    if (priceList) {
      priceList.innerHTML = html;
      return;
    }

    var priceNode = card.querySelector(".product-item__price, .price");
    if (priceNode) {
      priceNode.outerHTML = html;
    }
  }

  function updateImage(card, product, variant, title) {
    var image = variantImage(product, variant);
    if (!image) return;

    var images = Array.prototype.slice.call(card.querySelectorAll("img"));
    var primary =
      images.find(function (img) {
        return !img.classList.contains("product-item__secondary-image") && !img.hidden;
      }) || images[0];

    if (!primary) return;

    primary.removeAttribute("srcset");
    primary.removeAttribute("data-srcset");
    primary.setAttribute("src", image);
    primary.setAttribute("data-src", image);
    primary.setAttribute("alt", title);
    primary.hidden = false;
    primary.style.display = "";

    images.forEach(function (img) {
      if (img === primary) return;
      if (img.classList.contains("product-item__secondary-image") || img.hidden) {
        img.hidden = true;
        img.style.display = "none";
      }
    });

    var aspect = primary.closest(".aspect-ratio");
    if (aspect) {
      aspect.style.setProperty("--aspect-ratio", "1");
      aspect.style.paddingBottom = "100%";
    }
  }

  function updateProductImage(card, product) {
    updateImage(
      card,
      product,
      {
        featured_image: {
          src: product.featured_image || (product.images && product.images[0]) || "",
        },
      },
      product.title
    );
  }

  function updateQuickAdd(card, variant) {
    Array.prototype.slice.call(card.querySelectorAll('input[name="id"]')).forEach(function (input) {
      input.value = variant.id;
    });
  }

  function mutateCard(card, product, variant) {
    var title = variantTitle(product, variant);

    card.classList.add("cp-variant-grid-card");
    card.removeAttribute("data-cp-variant-excluded");
    card.setAttribute("data-cp-product-handle", product.handle);
    card.setAttribute("data-cp-variant-id", String(variant.id));
    card.setAttribute("data-cp-variant-title", variant.public_title || variant.title || "");
    card.classList.toggle("product-item--sold-out", variant.available === false);

    uniquifyIds(card, variant.id);
    updateLinks(card, product.handle, variant.id);
    updateTitle(card, title);
    updatePrice(card, variant);
    updateDiscountLabel(card, variant.price, variant.compare_at_price);
    updateImage(card, product, variant, title);
    updateQuickAdd(card, variant);

    return card;
  }

  function mutateParentCard(card, product) {
    card.classList.remove("cp-variant-grid-card");
    card.classList.add("cp-variant-grid-parent-card");
    card.setAttribute("data-cp-product-handle", product.handle);
    card.removeAttribute("data-cp-variant-id");
    card.removeAttribute("data-cp-variant-title");
    if (shouldExpandProduct(product)) {
      card.removeAttribute("data-cp-variant-excluded");
    } else {
      card.setAttribute("data-cp-variant-excluded", "true");
    }
    card.classList.toggle("product-item--sold-out", product.available === false);

    updateParentLinks(card, product.handle);
    updateTitle(card, product.title);
    updateProductPrice(card, product);
    updateProductImage(card, product);

    return card;
  }

  async function renderParent(cards) {
    var parent = getPrimaryParent(cards);
    var targetCards = parent
      ? cards.filter(function (card) {
          return card.parentElement === parent;
        })
      : cards;
    var sourceCards = uniqueCardsByHandle(targetCards);
    var keepCards = new Set(
      sourceCards.map(function (item) {
        return item.card;
      })
    );

    targetCards.forEach(function (card) {
      if (!keepCards.has(card)) {
        card.remove();
      }
    });

    await Promise.all(
      sourceCards.map(async function (item) {
        var product = await fetchProduct(item.handle);
        mutateParentCard(item.card, product);
      })
    );
  }

  async function renderModel(cards, state) {
    var parent = getPrimaryParent(cards);
    var targetCards = parent
      ? cards.filter(function (card) {
          return card.parentElement === parent;
        })
      : cards;
    var sourceCards = uniqueCardsByHandle(targetCards);
    var keepCards = new Set(
      sourceCards.map(function (item) {
        return item.card;
      })
    );

    targetCards.forEach(function (card) {
      if (!keepCards.has(card)) {
        card.remove();
      }
    });

    await Promise.all(
      sourceCards.map(async function (item) {
        var card = item.card;
        var handle = item.handle;
        var product = await fetchProduct(handle);

        if (!shouldExpandProduct(product)) {
          mutateParentCard(card, product);
          return;
        }

        var variant = findVariantForModel(product, state.model);

        if (!variant) {
          card.remove();
          return;
        }

        mutateCard(card, product, variant);
      })
    );
  }

  async function renderVariants(cards, state) {
    var parent = getPrimaryParent(cards);
    if (!parent) return;

    var sourceCards = uniqueCardsByHandle(
      cards.filter(function (card) {
        return card.parentElement === parent;
      })
    );

    var products = await Promise.all(
      sourceCards.map(async function (item) {
        return {
          item: item,
          product: await fetchProduct(item.handle),
        };
      })
    );
    var fragment = document.createDocumentFragment();

    products.forEach(function (entry) {
      var item = entry.item;
      var product = entry.product;
      if (!shouldExpandProduct(product)) {
        fragment.appendChild(mutateParentCard(item.card.cloneNode(true), product));
        return;
      }
      var variants = displayableVariants(product, state);

      variants.forEach(function (variant) {
        var card = item.card.cloneNode(true);
        mutateCard(card, product, variant);
        fragment.appendChild(card);
      });
    });

    parent.innerHTML = "";
    parent.appendChild(fragment);
  }

  function signatureFor(cards, state) {
    var handles = uniqueCardsByHandle(cards)
      .map(function (item) {
        return item.handle;
      })
      .join("|");

    return [state.mode, normalize(state.model), window.location.pathname, window.location.search, handles].join("::");
  }

  // Globo paginates parent products. Expanded promos need pages of final model
  // cards instead, so keep lightweight descriptors and clone only the page.
  function getCardPageSize(state) {
    return Number(CONFIG.pageSize) === 20 &&
      window.CPVariantGridPaginationReady === true && shouldMaskGrid(state) ? 20 : 0;
  }

  function pageQueryKey() {
    var params = getParams();
    params.delete("cp_page");
    params.delete("page");
    params.delete("limit"); // Globo adds its fixed transport limit after initial load.
    params.sort();
    return window.location.pathname + "?" + params.toString();
  }

  function buildCardEntries(products, state) {
    var entries = [];
    products.forEach(function (entry) {
      var variants = shouldExpandProduct(entry.product) ? displayableVariants(entry.product, state) : [null];
      if (state.mode === "model") variants = variants.slice(0, 1);
      variants.forEach(function (variant) {
        entries.push({item: entry.item, product: entry.product, variant: variant,
          rate: variant ? discountRate(variant.price, variant.compare_at_price) : 0, index: entries.length});
      });
    });
    return entries;
  }

  function sortedEntriesForPage(entries, state) {
    var ordered = entries.slice();
    if (shouldSortByDiscount(state)) ordered.sort(function (a, b) {
      var difference = b.rate - a.rate;
      return Math.abs(difference) > 0.000001 ? difference : a.index - b.index;
    });
    var size = getCardPageSize(state) || ordered.length || 1;
    var pageCount = Math.max(1, Math.ceil(ordered.length / size));
    var requested = Number(getParams().get("cp_page") || 1);
    var page = Number.isSafeInteger(requested) && requested > 0 ? Math.min(requested, pageCount) : 1;
    var start = (page - 1) * size;
    return {entries: ordered.slice(start, start + size), page: page, pageCount: pageCount,
      total: ordered.length, start: ordered.length ? start + 1 : 0, end: Math.min(start + size, ordered.length)};
  }

  function cardPageUrl(page) {
    var params = getParams();
    params.delete("page");
    if (page > 1) params.set("cp_page", String(page));
    else params.delete("cp_page");
    return window.location.pathname + (params.toString() ? "?" + params.toString() : "") + window.location.hash;
  }

  function clearCardPagination() {
    var nav = document.getElementById("cp-card-pagination");
    if (nav) nav.remove();
    document.documentElement.classList.remove("cp-card-pagination-active");
    paginatedGrid = null;
  }

  function renderCardPagination(parent, page) {
    var nav = document.getElementById("cp-card-pagination");
    if (!nav) {
      nav = document.createElement("nav");
      nav.id = "cp-card-pagination";
      nav.className = "cp-card-pagination";
      nav.setAttribute("aria-label", "Paginação dos modelos");
    }
    var previous = page.page > 1 ? '<a rel="prev" data-cp-page href="' + escapeHtml(cardPageUrl(page.page - 1)) + '">Anterior</a>' : '<span aria-disabled="true">Anterior</span>';
    var next = page.page < page.pageCount ? '<a rel="next" data-cp-page href="' + escapeHtml(cardPageUrl(page.page + 1)) + '">Próxima</a>' : '<span aria-disabled="true">Próxima</span>';
    nav.innerHTML = '<p role="status">Mostrando ' + page.start + '–' + page.end + ' de ' + page.total + ' modelos</p><div>' + previous +
      '<span aria-current="page">Página ' + page.page + ' de ' + page.pageCount + '</span>' + next + '</div>';
    parent.insertAdjacentElement("afterend", nav);
    document.documentElement.classList.add("cp-card-pagination-active");
  }

  async function renderPagedGrid(cards, state) {
    var key = pageQueryKey();
    var parent = getPrimaryParent(cards);
    if (!parent) return;
    var ownCards = cards.every(function (card) { return card.getAttribute("data-cp-paged-card") === "true"; });
    if (!ownCards) {
      var sourceCards = uniqueCardsByHandle(cards.filter(function (card) { return card.parentElement === parent; }));
      var products = await Promise.all(sourceCards.map(async function (item) {
        return {item: item, product: await fetchProduct(item.handle)};
      }));
      // A slow response must never overwrite newer Globo filter results.
      if (key !== pageQueryKey() || !parent.isConnected || sourceCards.some(function (item) { return item.card.parentElement !== parent; })) return;
      paginatedGrid = {key: key, parent: parent, entries: buildCardEntries(products, state)};
    } else if (!paginatedGrid || paginatedGrid.key !== key || paginatedGrid.parent !== parent) {
      return; // Wait for the filtered parent cards from Globo.
    }
    var page = sortedEntriesForPage(paginatedGrid.entries, state);
    var fragment = document.createDocumentFragment();
    page.entries.forEach(function (entry) {
      var card = entry.item.card.cloneNode(true);
      if (entry.variant) mutateCard(card, entry.product, entry.variant);
      else mutateParentCard(card, entry.product);
      card.setAttribute("data-cp-paged-card", "true");
      fragment.appendChild(card);
    });
    parent.replaceChildren(fragment);
    renderCardPagination(parent, page);
    if (!history.state || !history.state.cpCardPagination) {
      history.replaceState(Object.assign({}, history.state || {}, {cpCardPagination: true}), "", window.location.href);
    }
    if (getParams().has("cp_page") && getParams().get("cp_page") !== String(page.page)) {
      history.replaceState(history.state, "", cardPageUrl(page.page));
    }
    if (scrollAfterPage) {
      scrollAfterPage = false;
      parent.setAttribute("tabindex", "-1");
      parent.focus({preventScroll: true});
      (document.getElementById("gf-controls-container") || parent).scrollIntoView({block: "start"});
    }
    clearForcedLoading();
    setGridLoading(false);
  }

  function shouldSortByDiscount(state) {
    var requestedSort = getParams().get("sort_by");
    return CONFIG.sort === "discount-descending" &&
      (state.mode === "variants" || state.mode === "model") &&
      (!requestedSort || requestedSort === "manual");
  }

  function sortCardsByDiscount(cards, state) {
    if (!shouldSortByDiscount(state)) return;
    var parent = getPrimaryParent(cards);
    if (!parent) return;

    var entries = cards.filter(function (card) {
      return card.parentElement === parent;
    }).map(function (card, index) {
      var rate = Number(card.getAttribute("data-cp-discount-rate"));
      return { card: card, index: index, rate: Number.isFinite(rate) ? rate : 0 };
    });
    var sorted = entries.slice().sort(function (a, b) {
      var difference = b.rate - a.rate;
      return Math.abs(difference) > 0.000001 ? difference : a.index - b.index;
    });
    if (sorted.every(function (entry, index) { return entry === entries[index]; })) return;

    var fragment = document.createDocumentFragment();
    sorted.forEach(function (entry) { fragment.appendChild(entry.card); });
    parent.appendChild(fragment);
  }

  async function render() {
    if (isRendering) {
      needsRenderAfterCurrent = true;
      return;
    }

    removeExcludedComboCards();

    var state = resolveState();
    var pageSize = getCardPageSize(state);
    if (!pageSize && paginatedGrid) clearCardPagination();
    if (state.mode === "off") {
      normalizeParentCardLinks(collectCards());
      lastSignature = "";
      setGridLoading(false);
      return;
    }

    var cards = collectCards();
    if (!cards.length) {
      if (pageSize) {
        clearCardPagination();
        clearForcedLoading();
        setGridLoading(false);
        return;
      }
      if (shouldMaskGrid(state)) setGridLoading(true);
      return;
    }

    var signature = signatureFor(cards, state);
    if (!pageSize && state.mode === "model" && gridLooksReady(state)) {
      sortCardsByDiscount(cards, state);
      lastSignature = signatureFor(collectCards(), state);
      showLoadingIfNeeded();
      return;
    }

    if (signature === lastSignature && (!shouldMaskGrid(state) || gridLooksReady(state))) {
      showLoadingIfNeeded();
      return;
    }

    isRendering = true;
    if (shouldMaskGrid(state)) setGridLoading(true);
    log("render", state, cards.length);

    try {
      if (pageSize) {
        await renderPagedGrid(cards, state);
      } else if (state.mode === "model") {
        await renderModel(cards, state);
      } else if (state.mode === "parent") {
        await renderParent(cards);
      } else if (state.mode === "variants") {
        await renderVariants(cards, state);
      }

      sortCardsByDiscount(collectCards(), state);
      lastSignature = signatureFor(collectCards(), state);
    } catch (error) {
      console.warn("[CPVariantGrid]", error);
      if (pageSize) { clearForcedLoading(); setGridLoading(false); }
    } finally {
      showLoadingIfNeeded();
      window.setTimeout(function () {
        isRendering = false;
        if (needsRenderAfterCurrent) {
          needsRenderAfterCurrent = false;
          scheduleRender();
        }
      }, 0);
    }
  }

  function scheduleRender() {
    removeExcludedComboCards();
    showLoadingIfNeeded();
    window.clearTimeout(renderTimer);
    renderTimer = window.setTimeout(render, 80);
  }

  function observeDomChanges() {
    var observer = new MutationObserver(function () {
      if (isRendering) {
        needsRenderAfterCurrent = true;
        return;
      }

      scheduleRender();
    });

    observer.observe(document.documentElement, {
      childList: true,
      subtree: true,
    });
  }

  function observeUrlChanges() {
    var replace = history.replaceState;
    ["pushState", "replaceState"].forEach(function (method) {
      var original = history[method];
      history[method] = function () {
        var previousKey = pageQueryKey();
        var result = original.apply(this, arguments);
        if (getCardPageSize(resolveState()) && previousKey !== pageQueryKey() && getParams().has("cp_page")) {
          replace.call(history, history.state, "", cardPageUrl(1));
        }
        showLoadingIfNeeded();
        scheduleRender();
        return result;
      };
    });

    window.addEventListener("popstate", function (event) {
      // A card-page-only history entry is ours, not a new Globo product page.
      // Globo drops unknown URL params on popstate. Restore other filter states
      // by normal navigation; same-filter card pages can stay instant and local.
      if (getCardPageSize(resolveState()) && event.state && event.state.cpCardPagination) {
        event.stopImmediatePropagation();
        if (!paginatedGrid || paginatedGrid.key !== pageQueryKey()) {
          window.location.reload();
          return;
        }
      }
      showLoadingIfNeeded();
      scheduleRender();
    }, true);
  }

  function bindAppEvents() {
    [
      "globoFilterRenderCompleted",
      "globoFilterRenderFinish",
      "globo:filter:updated",
      "shopify:section:load",
      "collection:reloaded",
    ].forEach(function (eventName) {
      document.addEventListener(eventName, function () {
        showLoadingIfNeeded();
        scheduleRender();
      });
      window.addEventListener(eventName, function () {
        showLoadingIfNeeded();
        scheduleRender();
      });
    });
  }

  function modelTextFromControl(control) {
    if (!control) return "";

    if (control.tagName === "INPUT") {
      var label =
        control.closest("label") ||
        (control.id ? document.querySelector('label[for="' + control.id + '"]') : null);
      return (label && label.textContent) || control.value || control.getAttribute("aria-label") || "";
    }

    return control.textContent || control.getAttribute("aria-label") || "";
  }

  function isModelFilterInteraction(target) {
    if (!target || !target.closest) return false;

    var control = target.closest('button,label,input,[role="checkbox"],[role="button"]');
    if (!control) return false;
    if (control.closest(".product-item,product-item,.collection__item,.spf-product-card,[data-product-id]")) {
      return false;
    }

    return Boolean(canonicalModel(modelTextFromControl(control)));
  }

  function handleFilterInteraction(event) {
    if (!isModelFilterInteraction(event.target)) return;

    forceGridLoading();
    window.setTimeout(scheduleRender, 120);
    window.setTimeout(scheduleRender, 600);
    window.setTimeout(scheduleRender, 1500);
    window.setTimeout(scheduleRender, 3000);
    window.setTimeout(scheduleRender, 6000);
  }

  function bindFilterInteractions() {
    document.addEventListener("click", function (event) {
      var link = event.target.closest && event.target.closest("#cp-card-pagination a[data-cp-page]");
      if (!link || event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
      event.preventDefault();
      scrollAfterPage = true;
      history.pushState(Object.assign({}, history.state || {}, {cpCardPagination: true}), "", link.href);
    });
    ["pointerdown", "click", "change"].forEach(function (eventName) {
      document.addEventListener(eventName, handleFilterInteraction, true);
    });
  }

  function injectStyle() {
    if (document.getElementById("cp-variant-grid-style")) return;

    var style = document.createElement("style");
    style.id = "cp-variant-grid-style";
    style.textContent = [
      "html.cp-variant-grid-loading #facet-main .product-facet__main,html.cp-variant-grid-loading #facet-main .product-list,html.cp-variant-grid-loading #facet-main .product-list__inner,html.cp-variant-grid-loading #facet-main .collection,html.cp-variant-grid-loading #facet-main .collection__main{position:relative;min-height:280px;}",
      "html.cp-variant-grid-loading #facet-main .product-facet__main>*,html.cp-variant-grid-loading #facet-main .collection__main>*{visibility:hidden!important;}",
      "html.cp-variant-grid-loading #facet-main product-item.product-item,html.cp-variant-grid-loading #facet-main .collection__item.product-item,html.cp-variant-grid-loading #facet-main .product-list__inner>.product-item,html.cp-variant-grid-loading #facet-main .product-list__inner>product-item,html.cp-variant-grid-loading #facet-main .spf-product-card,html.cp-variant-grid-loading #facet-main [data-product-id]{visibility:hidden!important;}",
      "html.cp-variant-grid-loading #facet-main .product-facet__main:before,html.cp-variant-grid-loading #facet-main .product-list__inner:before,html.cp-variant-grid-loading #facet-main .product-list:before{content:'Carregando modelos...';visibility:visible!important;position:absolute;left:0;right:0;top:72px;text-align:center;color:#b97765;font-size:13px;font-weight:600;letter-spacing:.04em;text-transform:uppercase;}",
      ".cp-variant-grid-card .product-item__secondary-image{display:none!important;}",
      ".cp-variant-grid-card .price-list{gap:.35rem;}",
      ".cp-card-pagination{margin:32px auto;max-width:540px;text-align:center;clear:both;}",
      ".cp-card-pagination p{margin:0 0 16px;font-size:13px;opacity:.7;}",
      ".cp-card-pagination>div{display:flex;align-items:center;justify-content:space-between;gap:12px;font-size:14px;}",
      ".cp-card-pagination a{display:inline-flex;align-items:center;justify-content:center;min-height:44px;padding:8px 16px;border:1px solid currentColor;border-radius:6px;}",
      ".cp-card-pagination [aria-disabled]{opacity:.35;padding:8px 16px;}",
      ".cp-card-pagination a:focus-visible{outline:2px solid currentColor;outline-offset:3px;}",
      "html.cp-card-pagination-active #gf-grid .gf-pagination,html.cp-card-pagination-active #gf-grid .pagination{display:none!important;}",
    ].join("");
    document.head.appendChild(style);
  }

  function init() {
    injectStyle();
    observeUrlChanges();
    observeDomChanges();
    bindAppEvents();
    bindFilterInteractions();
    showLoadingIfNeeded();
    scheduleRender();
    window.addEventListener("load", scheduleRender);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})();
